<div class="sh-form-group" [class.-sh-is-invalid]="invalid" [class]="formGroupStyling">
    <sh-form-label
        [label]="label"
        [required]="required"
        [helpText]="helpText"
        [for]="id"
        [labelIcons]="labelIcons"
        [actionItems]="labelActionItems"
    ></sh-form-label>

    <ng-content select="[slot='inputPrefix']"></ng-content>

    <div class="sh-input-field-with-action" *ngIf="currentActionItems; else inputField">
        <ng-container *ngTemplateOutlet="inputField"></ng-container>
        <sh-action-item *ngFor="let item of currentActionItems" [item]="item" class="sh-action-group__item"> </sh-action-item>
    </div>

    <ng-template #inputField>
        <ng-content></ng-content>
    </ng-template>

    <p *ngIf="invalid && errorMsg" [id]="describeLabelId" class="sh-form-group__feedback">{{ errorMsg }}</p>
</div>
